import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings } from 'lucide-react';
interface UserIdScreenProps {
  onSubmit: (userId: string) => void;
  onBack: () => void;
  fromEmail?: boolean;
  onSkip?: () => void;
}
export function UserIdScreen({
  onSubmit,
  onBack,
  fromEmail = false,
  onSkip
}: UserIdScreenProps) {
  const [userId, setUserId] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (userId.trim()) {
      onSubmit(userId);
    }
  };
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-330">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-331">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-20 blur-sm" data-id="element-332" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 to-slate-900/70" data-id="element-333" />
      </div>

      {/* Header - Higher z-index */}
      <div className="absolute top-6 left-6 right-6 z-50 flex items-center justify-between" data-id="element-334">
        <button onClick={onBack} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-335">
          <ArrowLeft className="w-5 h-5" data-id="element-336" />
          <span className="text-sm" data-id="element-337">Back</span>
        </button>
        <button className="p-3 rounded-full bg-slate-800/50 backdrop-blur-sm border border-white/10 hover:bg-slate-700/50 transition-colors" data-id="element-338">
          <Settings className="w-6 h-6 text-white" data-id="element-339" />
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-340">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-slate-800/80 backdrop-blur-xl rounded-2xl p-12 border border-white/10 shadow-2xl max-w-md w-full" data-id="element-341">
          <form onSubmit={handleSubmit} data-id="element-342">
            <h2 className="text-xl text-white/80 text-center mb-8 uppercase tracking-wider" data-id="element-343">
              {fromEmail ? 'Enter User ID from Email:' : 'Verify Your Email for User ID:'}
            </h2>

            <input type="text" value={userId} onChange={e => setUserId(e.target.value)} placeholder={fromEmail ? 'User ID' : '5724'} className="w-full px-6 py-4 bg-slate-700/50 border border-white/10 rounded-lg text-white placeholder-white/40 focus:outline-none focus:border-white/30 transition-colors mb-6 text-center" data-id="element-344" />

            <button type="submit" disabled={!userId.trim()} className="w-full px-8 py-3 bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 disabled:from-slate-700 disabled:to-slate-600 text-white font-medium rounded-lg transition-all disabled:cursor-not-allowed disabled:opacity-50 uppercase tracking-wider" data-id="element-345">
              Login
            </button>

            {onSkip && <button type="button" onClick={onSkip} className="mt-4 text-white/30 hover:text-white/60 text-sm transition-colors mx-auto block" data-id="element-346">
                Guest access →
              </button>}
          </form>
        </motion.div>
      </div>
    </div>;
}